import axios from 'axios'
import router from '../../router'

const state = {
  adminGroupMenus: []
}

const getters = {
  getAdminGroupMenus (state) {
    return state.adminGroupMenus
  }
}

const mutations = {
  setAdminGroupMenus (state, payload) {
    state.adminGroupMenus = payload
  }
}

const actions = {
  apiSysadminGroupMenus (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      if (payload.method === 'POST') {
        axios.post('/api/sysadmin/GroupMenus', payload)
          .then((response) => {
            console.log(response.data)
            context.dispatch('apiSysadminGroupMenus', {'groupId': payload.user_group_id, 'method': 'GET'})
            alert('메뉴권한이 추가되었습니다.')
          })
          .catch((error) => {
            alert(error.response.data.message)
            if (error.response.status === 410) {
              sessionStorage.removeItem('token')
              router.push('/sessiontimeout')
            }
          })
      } else if (payload.method === 'DELETE') {
        axios.delete('/api/sysadmin/GroupMenus/' + payload.group_menu_id)
          .then((response) => {
            console.log(response.data)
            context.dispatch('apiSysadminGroupMenus', {'groupId': payload.user_group_id, 'method': 'GET'})
            alert('메뉴권한이 해제되었습니다.')
          })
          .catch((error) => {
            alert(error.response.data.message)
            if (error.response.status === 410) {
              sessionStorage.removeItem('token')
              router.push('/sessiontimeout')
            }
          })
      } else { // GET method
        axios.get('/api/sysadmin/GroupMenus/' + payload.groupId)
          .then((response) => {
            console.log(response.data)
            context.commit('setAdminGroupMenus', response.data)
          })
          .catch((error) => {
            alert(error.response.data.message)
            if (error.response.status === 410) {
              sessionStorage.removeItem('token')
              router.push('/sessiontimeout')
            }
          })
      }
    } else {
      alert('세션 만료 또는 잘못된 접근 입니다.')
      router.push('/sessiontimeout')
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/admingroupauth.js